export const Badge = {}

export default Badge
